define.alias("shared/utils/formatters/ig-user-from-graph", "settings/utils/formatters/ig-user-from-graph");